import brand from '../../brand';
import { createBEM } from './bem';
import { createComponent } from './component';
import { createI18N } from './i18n';
export function createBrandName() {
  return brand.createBrandName();
}
export function createNamespace(name) {
  var brandName = createBrandName();
  name = brandName + name;
  return [createComponent(name), createBEM(name), createI18N(name)];
}